import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'
import user from './modules/user'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    getters
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  state: {
    activeIndex: '/monitor', // 激活状态
    openTab: [], // 所有打开的路由
    indexActive: 1, // 一级菜单选项
    indexPathId: '', // 左侧菜单选择
    // 路由
    isPath: true,
    // 天气
    weatherData: {
      weather: '',
      temperature: ''
    },
    csdsip: '', // 开关下线需要
    isSip: false, // 坐席开关
    // 单双号
    evenNumber: true,
    isMqtt: false, // 即构视频 弃
    acceptVideo: {
      isCall: false,
      deviceid: ''
    }
  },
  mutations: {
    // 退出恢复原样
    tabs (state, data) {
      // console.log(data)
      state.openTab = data
      state.indexActive = 1
      state.indexPathId = ''
    },
    // 添加tabs
    add_tabs (state, data) {
      this.state.openTab.push(data)
    },
    // 删除tabs
    delete_tabs (state, route) {
      let index = 0
      for (let option of state.openTab) {
        if (option.route === route) {
          break
        }
        index++
      }
      this.state.openTab.splice(index, 1)
    },
    // 删除全部tabs
    delete_tabs_all (state, data) {
      state.openTab = [data]
    },
    // 设置当前激活的tab
    set_active_index (state, index) {
      this.state.activeIndex = index
    },
    set_path (state, path) {
      state.isPath = path
    },
    set_weather (state, weather) {
      state.weatherData = weather
    },
    set_csdsip (state, csdsip) {
      state.csdsip = csdsip
    },
    set_isSip (state, isSip) {
      state.isSip = isSip
    },
    set_evenNumber (state, evenNumber) {
      state.evenNumber = evenNumber
    },
    set_is_mqtt (state, isMqtt) {
      state.isMqtt = isMqtt
    },
    // 菜单
    set_is_indexActive (state, indexActive) {
      state.indexActive = indexActive
    },
    set_is_indexPathId (state, indexPathId) {
      state.indexPathId = indexPathId
    }
  },
  getters: {
    openTab (state) {
      return state.openTab
    },
    activeIndex (state) {
      return state.activeIndex
    },
    get_path (state) {
      return state.isPath
    },
    get_weather (state) {
      return state.weatherData
    },
    get_csdsip (state) {
      return state.csdsip
    },
    get_isSip (state) {
      return state.isSip
    },
    get_evenNumber (state) {
      return state.evenNumber
    },
    get_is_mqtt (state) {
      return state.isMqtt
    },
    get_is_indexActive (state) {
      return state.indexActive
    },
    get_is_indexPathId (state) {
      return state.indexPathId
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js